var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 52 52",
    enableBackground: "new 0 0 52 52",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44,2H20c-2.2,0-4,1.8-4,4v0.1c0,0.7,0.4,1.4,1,1.8c0.3,0.2,4.1,4,4.1,4c0.3,0.3,0.8,0,0.8-0.4l0,0 c0-0.8,0.7-1.6,1.5-1.6h17c0.8,0,1.6,0.8,1.6,1.6v27c0,0.8-0.8,1.4-1.6,1.4h-17c-0.8,0-1.4-0.6-1.4-1.4v-0.1c0-0.4-0.5-0.6-0.8-0.3 c0,0-3.8,3.8-4.2,4c-0.6,0.4-1,1-1,1.8v2c0,2.2,1.7,4,3.9,4h24c2.2,0,4.1-1.8,4.1-4V6C48,3.8,46.2,2,44,2z M32,48c-1.7,0-3-1.3-3-3 s1.3-3,3-3s3,1.3,3,3S33.7,48,32,48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6,23.9L15.1,11.4c-0.6-0.6-1.5-0.6-2.1,0l-2.1,2.1c-0.6,0.6-0.6,1.5,0,2.1l4.6,4.6 c0.6,0.6,0.2,1.7-0.7,1.7H1.5C0.7,22,0,22.7,0,23.5v3C0,27.3,0.7,28,1.5,28h13.2c0.9,0,1.3,1.1,0.7,1.7l-4.6,4.6 c-0.6,0.6-0.6,1.5,0,2.1l2.1,2.1c0.6,0.6,1.5,0.6,2.1,0L27.6,26C28.1,25.5,28.1,24.5,27.6,23.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPush);
export default __webpack_public_path__ + "static/media/Push.3960d4251c3ea5c978f2ea45a3deb73c.svg";
export { ForwardRef as ReactComponent };